import PropTypes from "prop-types";
import "./CreditCardPaymentType.scss";
import { FormattedDate, FormattedMessage } from "react-intl";
import AmountContainer from "app/pages/.shared/AmountContainer";
import CreditCardMarketingBannerContainer from "app/pages/Booking/Payment/CreditCardMarketingBanner/CreditCardMarketingBannerContainer";
import CreditCardFieldsetContainer from "app/pages/Booking/Payment/CreditCardFieldset/CreditCardFieldsetContainer";

const CreditCardPaymentType = ({
	payNowAmount,
	payLaterAmount,
	dueDate,
	onCreditCardInputsBlur,
	useAdyen = true,
	onAdyenComponentMounted = () => {},
	showAmountToPay,
}) => {
	return (
		<div className="creditcard-payment-type">
			<div className="creditcard-payment-type__marketing">
				<CreditCardMarketingBannerContainer />
			</div>
			<div className="creditcard-payment-type__pay-amount">
				{payLaterAmount > 0 ? (
					<FormattedMessage id="payment.pay.now.amount" />
				) : (
					<FormattedMessage id="payment.pay.all" />
				)}
				<span>
					<AmountContainer amount={payNowAmount} />
				</span>
			</div>
			{payLaterAmount > 0 && (
				<div className="creditcard-payment-type__pay-amount creditcard-payment-type__pay-amount--subtitle">
					<FormattedMessage
						id="payment.pay.later.amount"
						values={{
							dueDate: (
								<FormattedDate
									timeZone="UTC"
									day="2-digit"
									month="2-digit"
									year="numeric"
									value={dueDate}
								/>
							),
						}}
					/>
					<span>
						<AmountContainer amount={payLaterAmount} />
					</span>
				</div>
			)}
			<CreditCardFieldsetContainer
				onBlur={onCreditCardInputsBlur}
				showAmountToPay={showAmountToPay}
				useAdyen={useAdyen}
				onAdyenComponentMounted={onAdyenComponentMounted}
			/>
		</div>
	);
};

CreditCardPaymentType.propTypes = {
	payNowAmount: PropTypes.number,
	onAdyenComponentMounted: PropTypes.func,
	useAdyen: PropTypes.bool,
	payLaterAmount: PropTypes.number,
	dueDate: PropTypes.number,
	onCreditCardInputsBlur: PropTypes.func,
	showAmountToPay: PropTypes.bool,
};

export default CreditCardPaymentType;
